import React from 'react';
import PropTypes from 'prop-types';
import useCollectionState from 'Hooks/useCollectionState';

const CollectionStateContext = React.createContext(undefined);

const CollectionStateProvider = ({
  children,
  args,
}) => {
  const state = useCollectionState(args);

  return (
    <CollectionStateContext.Provider value={state}>
      {children}
    </CollectionStateContext.Provider>
  );
};

// Use CollectionState State Context
const useCollectionStateContext = () => {
  const context = React.useContext(CollectionStateContext);
  if (context === undefined) {
    throw new Error('useCollectionStateContext must be used within a CollectionStateProvider');
  }
  return context;
};

CollectionStateProvider.defaultProps = {
  args: {},
};

CollectionStateProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  args: PropTypes.object,
};

export {
  CollectionStateProvider,
  useCollectionStateContext,
};
